export default {"src":"/_next/static/media/program.542afe74.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};